import { useCallback, useEffect, useState } from 'react'
import { useLocalStorageState } from 'ahooks'
import { useModel } from '@umijs/max'

let imgCollectsRef = { text: '', chooseBox: null, tag: [], isLoad: true, tags: [], identifyResults: [] as { box: number[]; text: string }[] }

export default () => {
  // isHoverExpand
  const { isHoverExpand }: { isHoverExpand: boolean } = useModel('detail')
  const { iframePlaceholderExpand }: { iframePlaceholderExpand: boolean } = useModel('common')

  const [imgCollects, setImgCollects] = useState({ text: '', chooseBox: null, tag: [], isLoad: true, tags: [], identifyResults: [] as { box: number[]; text: string }[] })
  // 当前以图搜图,接口用
  const [searchImg, setSearchImg] = useState("")
  // 用户已选择图片，但 searchImg 尚未生成时提前进入图搜加载布局
  const [imageSearchPending, setImageSearchPending] = useState(false)
  const [isLoadList, setIsLoadList] = useState(false)

  // 以图搜图的图片地址，回填显示用
  const [searchImgUrl, setSearchImgUrl] = useState("")
  // 图片搜索结果页补充的用户关键词
  const [imageKeyword, setImageKeyword] = useState("")

  // 识别的点集合
  const [isAutoOpen, setIsAutoOpen] = useLocalStorageState<boolean>('search-img-state', {
    defaultValue: true
  });

  const [isModalVisible, setIsModalVisible] = useState(false)
  const toggleSearchImg = useCallback((val: string) => {
    if (!val) {
      toggleImgCollects({ text: '', chooseBox: null, tag: '', identifyResults: [] })
      setImageKeyword('')
    }
    setSearchImg(val)
  }, [])
  const toggleImgCollects = useCallback((val: any) => {
    imgCollectsRef = {
      ...imgCollectsRef,
      ...val
    }
    if (val.tags && val.tags.length > 0) {
      setImgCollects({
        ...imgCollectsRef,
        ...val
      })
    } else {
      setImgCollects({
        ...imgCollectsRef,
        ...val
      })
      imgCollectsRef = {
        ...imgCollectsRef,
        ...val
      }
    }
  }, [])
  useEffect(() => {
    if (isHoverExpand && iframePlaceholderExpand) {
      setIsModalVisible(false)
    }
  }, [isHoverExpand, iframePlaceholderExpand])
  return {
    toggleImgCollects,
    imgCollects,
    searchImg,
    toggleSearchImg,
    imageSearchPending,
    setImageSearchPending,
    searchImgUrl,
    setSearchImgUrl,
    imageKeyword,
    setImageKeyword,
    isLoadList,
    setIsLoadList,
    isAutoOpen,
    setIsAutoOpen,
    isModalVisible,
    setIsModalVisible
  }
}
